import type { AppConfig } from '@ms-cloudpack/common-types';
import { mergeObjects } from '@ms-cloudpack/package-utilities';

/**
 * Merge the configs. Later parent configs override earlier ones.
 */
export function mergeParentConfig(params: { appConfig: AppConfig; parentConfigs: AppConfig[] }): AppConfig {
  const result = mergeObjects([...params.parentConfigs, params.appConfig], {
    arrayMerge: 'overwrite',
    customMerge: {
      // Concatenate package settings
      packageSettings: (prev, curr) => [...(prev ?? []), ...(curr ?? [])],

      // Concatenate telemetry
      telemetry: (prev, curr) => ({ ...prev, ...curr }),
    },
  });

  // Remove the extends property from the result
  delete result.extends;

  return result;
}
